import { store } from './store';

export const toggleShowGps = () => {
  store.layout.showGps = !store.layout.showGps;
};
